// components/common/Modal/Modal.jsx
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';

import { closeModal, selectModal } from '../../../redux/slices/modalSlice';

import ContactModal from './ContactModal';
import JobApplyModal from './JobApplyModal';

import './Modal.scss';

const Modal = () => {
    const dispatch = useDispatch();
    const { isOpen, modalType, modalProps } = useSelector(selectModal);

    const handleClose = () => {
        dispatch(closeModal());
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    const renderModalContent = () => {
        switch (modalType) {
            case 'contact':
                return <ContactModal {...modalProps} onClose={handleClose} />;
            case 'job_apply':
                return <JobApplyModal {...modalProps} onClose={handleClose} />;
            default:
                return null;
        }
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="modal-backdrop"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={handleBackdropClick}
                >
                    <motion.div
                        className="modal-container"
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.9, opacity: 0 }}
                        transition={{ type: 'spring', damping: 25, stiffness: 300 }}
                    >
                        <button className="modal-close-btn" onClick={handleClose}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </button>
                        {renderModalContent()}
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Modal;